// extracted by mini-css-extract-plugin
export default {"container":"INhZpQrh","icon":"r1twOZzJ","iconContainer":"Goi1t0p5","label":"lH0VCtsk","item":"G8ibexfw"};